import React, { useState, useEffect, useRef, useCallback } from "react";
import { Routes, Route, useNavigate, Outlet } from "react-router-dom";
import Header from "../components/studDashboard/Header";
import Sidebar from "../components/studDashboard/Sidebar";
import ProfileRoutes from "../profile/ProfileRoutes";
import Dashboard from "./StudentDashboard";
import CourseDisplay from "../coursePlatform/CourseDisplay";

const DashboardRouter = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    window.innerWidth > 768
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const sidebarRef = useRef(null);
  const burgerMenuRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/auth/login");
    }
  }, [navigate]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);

      if (!mobile) {
        setIsSidebarOpen(false);
        setIsSidebarCollapsed(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleSidebar = useCallback(() => {
    if (isMobile) {
      setIsSidebarOpen((prev) => !prev);
    } else {
      setIsSidebarCollapsed((prev) => !prev);
    }
  }, [isMobile]);

  const closeSidebar = useCallback(() => {
    if (isMobile) {
      setIsSidebarOpen(false);
    } else {
      setIsSidebarCollapsed(true);
    }
  }, [isMobile]);

  const handleMouseDown = useCallback(
    (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        burgerMenuRef.current &&
        !burgerMenuRef.current.contains(event.target) &&
        (isMobile ? isSidebarOpen : !isSidebarCollapsed)
      ) {
        closeSidebar();
      }
    },
    [isMobile, isSidebarOpen, isSidebarCollapsed, closeSidebar]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleMouseDown);
    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, [handleMouseDown]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeSidebar();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [closeSidebar]);

  return (
    <div className="min-h-screen bg-gray-50">
<div className="fixed top-0 left-0 right-0 z-50">
  <Header toggleSidebar={toggleSidebar} burgerMenuRef={burgerMenuRef} />
</div>

      <div className="flex">
        <div ref={sidebarRef}>
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            isSidebarCollapsed={isSidebarCollapsed}
            isMobile={isMobile}
            closeSidebar={closeSidebar}
          />
        </div>
        
        <div
          className={`
            flex-1 transition-all duration-300 ease-in-out
            ${isMobile
              ? isSidebarOpen && "pointer-events-none"
              : !isSidebarCollapsed && "pointer-events-none"
            }
          `}
        >
          <div
            className={`
              transition-all duration-300 ease-in-out pt-20 p-8
              ${isMobile
  ? isSidebarOpen && "blur-[1px] brightness-95"
  : !isSidebarCollapsed && "blur-[1px] brightness-95"}

              ${isMobile 
                ? "ml-0" 
                : isSidebarCollapsed 
                  ? "ml-16" 
                  : "ml-64"
              }
            `}
          >
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/profile/*" element={<ProfileRoutes />} />
              <Route path="/course" element={<CourseDisplay />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardRouter;